<template>
	<div class="kbBox" v-loading.fullscreen.lock="fullscreenLoading">
		<dialogBox :dialogFlag="fxFlag" wid="550px" @callFn="fxFlag = false" :title="`作答统计`">
			<div class="tjBoxs">
				<!-- <div class="tjBoxItem">
          <div ref="myChart1" style="width: 350px; height: 300px;"></div>
        </div> -->
				<div class="tjBoxItem">
					<div ref="myChart2" style="width: 350px; height: 300px"></div>
				</div>
			</div>
			<div slot="footer"></div>
		</dialogBox>
		<div class="kbTit">
			<div class="kbFanh" @click="fhKeben">
				<i class="el-icon-arrow-left"></i>
				返回{{ tabName }}
			</div>
			<div class="kbTjRig">
				<div class="kbTj" @click="zFlag = 2" v-if="zFlag == 1">
					<img src="@/assets/img/tji.svg" alt="" />
					作答统计
				</div>
				<div class="kbTj" @click="fxFn" v-if="zFlag == 2">
					<img src="@/assets/img/tji.svg" alt="" />
					图表统计
				</div>
				<div class="kbTj banjJcBtn" @click="zFlag = 1" v-if="zFlag == 2">
					<i class="el-icon-notebook-1"></i>
					错题分布
				</div>
			</div>
		</div>
		<div class="ctTabelBox" v-if="zFlag == 1">
			<div class="ctTabelTit">
				<div class="ctTabelTitItem" v-for="(item, index) in tabData" :key="index">
					{{ thData[index] }}
				</div>
			</div>
			<div class="ctTabelCont">
				<div
					class="ctTabelContItem"
					:class="index == tabInex ? 'ctTabelContItemActive' : ''"
					@click="
						tabFn(item, item.n);
						tabInex = index;
					"
					v-for="(item, index) in tabData"
					:key="index"
				>
					{{ item.wrongStuNums }}
				</div>
			</div>
		</div>
		<div class="kbCont" v-if="zFlag == 1 && tabVal != '-1'">
			<div class="kaoshiCont">
				<div class="kaoshiFixYs">
					<div class="kaoshiFixYsCont">
						{{ bsData.slice(bsIns, bsIns + 1)[0] + 'x' }}
					</div>
					<div class="kaoshiFixP">
						<img src="@/assets/img/x.png" @click="yusFn('-')" class="img1" alt="" />
						<p>语速调节</p>
						<img src="@/assets/img/s.svg" @click="yusFn('+')" class="img2" alt="" />
					</div>
				</div>
				<div class="kaoshiTm" v-if="tmData">
					<div class="kaoshiTmFbts">试题编号：{{ tmData?.yydGroupExamQuestionBodyDtoList[tabVal]?.number }}</div>
					<div class="kaoshiTmFbt">
						听材料回答以下{{ thData[tmData?.yydGroupExamQuestionBodyDtoList[tabVal]?.yydSmallQuestionList.length - 1] }}小题
						<!-- <div class="kaoshiWtBtn" @click="jtBtns(tmData?.yydGroupExamQuestionBodyDtoList[tabVal])">
                <img src="@/assets/img/形状.png" alt="">
                精听
              </div> -->
						<jting-button @btns="jtBtns(tmData?.yydGroupExamQuestionBodyDtoList[tabVal])" @qkFn="qkFn" :ref="'jting'" />
					</div>
					<div
						class="kaoshiT"
						:class="{ cwActive: false }"
						v-for="(fitem, findex) in tmData?.yydGroupExamQuestionBodyDtoList[tabVal]?.yydSmallQuestionList"
						:key="findex"
					>
						<div class="kaoshiWt">
							<div class="kaoshiDa">
								<i>(</i>
								<span>{{ fitem.tmVal }}</span>
								<i>)</i>
							</div>
							<div class="tips">{{ findex + 1 }}、{{ fitem.title }}</div>
						</div>
						<div class="kaoshiXx">
							<p v-for="(item, index) in fitem.yydSmallQuestionOptionList" @click="fitem.tmVal = item.number" :key="index">{{ item.number }}、{{ item.content }}</p>
						</div>
					</div>
					<div class="lookJxWrapper">
						<div class="lookJx" @click="changelookJx">
							查看解析
							<i class="el-icon-caret-bottom" v-if="!tmData?.yydGroupExamQuestionBodyDtoList[tabVal]?.tmFlag"></i>
							<i class="el-icon-caret-top" v-if="tmData?.yydGroupExamQuestionBodyDtoList[tabVal]?.tmFlag"></i>
						</div>
						<div class="lookDaBox" v-show="tmData?.yydGroupExamQuestionBodyDtoList[tabVal]?.tmFlag">
							<div class="lookDaTit">
								正确答案：
								<span v-for="(fitem, findex) in tmData?.yydGroupExamQuestionBodyDtoList[tabVal]?.yydSmallQuestionList" :key="findex">{{ fitem.answer }}</span>
							</div>
							<div class="lookDaCont">
								<p v-html="tmData?.yydGroupExamQuestionBodyDtoList[tabVal].originalContent"></p>
							</div>
							<div class="lookDaBtn" @click="tltBtn(tmData?.yydGroupExamQuestionBodyDtoList[tabVal])">加入错题本</div>
						</div>
					</div>
				</div>
				<ctHz :tableData="tableData" />
			</div>
		</div>
		<el-empty v-if="zFlag == 1 && tabVal == '-1'" description="暂无信息"></el-empty>
		<div class="kbCont" v-if="zFlag == 2">
			<el-table ref="multipleTable" :data="perData" header-row-class-name="btClass" tooltip-effect="dark" style="width: 100%">
				<el-table-column align="center" prop="createNickName" label="姓名"></el-table-column>
				<el-table-column align="center" prop="createTime" label="作答时间">
					<template slot-scope="scope">
						<div>
							{{ scope.row.createTime | momentYR('YYYY年MM月DD日') }}
						</div>
					</template>
				</el-table-column>
				<el-table-column align="center" label="正确数">
					<template slot-scope="scope">
						<div class="dfIcon">
							<img src="@/assets/img/zq.svg" alt="" />
							{{ scope.row.rightNum || 0 }}
						</div>
					</template>
				</el-table-column>
				<el-table-column align="center" label="错误数">
					<template slot-scope="scope">
						<div class="dfIcon dfIcon1">
							<img src="@/assets/img/cwu.svg" alt="" />
							{{ scope.row.wrongNum || 0 }}
						</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="score" label="套题得分"></el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
import * as echarts from 'echarts';
import dialogBox from '@/components/pubComponents/dialogBox';
import ctHz from '@/components/pubComponents/ctHz.vue';
import axios from 'axios';

export default {
	name: 'banjiSjDecSec',
	data() {
		const _this = this;
		return {
			tmFlag: false,
			fxFlag: false,
			bsData: ['0.5', '0.75', '1', '1.25', '1.5', '1.75'],
			thData: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十'],
			bsIns: 2,
			tableData: [],
			perData: [],
			zFlag: 1,
			fullscreenLoading: false,
			tabVal: 0,
			tabInex: 0,
			tmData: '', // 题目详情
			daJh: [
				{
					tmName: 'asdasd',
					tms: [
						{
							d: 'B',
							jxFlag: false,
							cw: false
						},
						{
							d: 'C',
							jxFlag: false,
							cw: true
						},
						{
							d: 'A',
							jxFlag: false,
							cw: false
						}
					]
				}
			],
			myChart1: '',
			myChart2: '',
			option1: {
				title: {
					text: `套题
完成率`,
					left: '48.5%',
					top: '43%',
					subtextStyle: {
						color: '#9B9C9E',
						fontSize: 12,
						fontWeight: 'bold'
					},
					textAlign: 'center'
				},
				tooltip: {
					trigger: 'item'
				},
				legend: {
					bottom: 'bottom'
					// formatter: function (params) {
					//   console.log(params,999)
					//     return `${params} ${_this.option1.series[0].data.filter(item => item.name == params)[0].value}`;
					// },
				},
				series: [
					{
						name: '套题完成率',
						type: 'pie',
						radius: ['30%', '50%'],
						avoidLabelOverlap: false,
						label: {
							formatter: '{c}人',
							fontSize: 14
						},
						data: []
					}
				]
			},
			option2: {
				title: {
					text: `套题
得分率`,
					left: '48.5%',
					top: '43%',
					subtextStyle: {
						color: '#9B9C9E',
						fontSize: 12,
						fontWeight: 'bold'
					},
					textAlign: 'center'
				},
				tooltip: {
					trigger: 'item'
				},
				legend: {
					bottom: 'bottom'
					// formatter: function (params) {
					//   console.log(params,999)
					//     return `${params} ${_this.option1.series[0].data.filter(item => item.name == params)[0].value}`;
					// },
				},
				series: [
					{
						name: '套题得分率',
						type: 'pie',
						radius: ['30%', '50%'],
						avoidLabelOverlap: false,
						label: {
							formatter: '{c}人',
							fontSize: 14
						},
						data: []
					}
				]
			}
		};
	},
	components: {
		dialogBox,
		ctHz
	},
	computed: {
		tabName() {
			return this.$parent.flags == 3 ? '班级试卷' : this.$parent.flags == 4 ? '高考真题' : this.$parent.flags == 5 ? '每日一听' : this.$parent.flags == 8 ? '机考套题' : '';
		},
		tabData() {
			let arr = [];
			if (this.tmData.yydGroupExamQuestionBodyDtoList) {
				this.tmData.yydGroupExamQuestionBodyDtoList.forEach((item, index) => {
					item.yydSmallQuestionList.forEach((i) => {
						i.n = index;
						arr.push(i);
					});
				});
			}
			return arr;
		}
	},
	props: ['bjId', 'ctId', 'examId', 'pageType', 'paperId', 'paperType'],
	methods: {
		changelookJx() {
			this.tmData.yydGroupExamQuestionBodyDtoList[this.tabVal].tmFlag = !this.tmData.yydGroupExamQuestionBodyDtoList[this.tabVal].tmFlag
		},
		qkFn() {
			console.log(this.$refs['jting'].length, 9999);
			if (this.$refs['jting'].length) {
				this.$refs['jting'].forEach((item) => {
					item.btnFlag = false;
					item.bfFlag = true;
				});
			} else {
				this.$refs['jting'].btnFlag = false;
				this.$refs['jting'].bfFlag = true;
			}
		},
		jtBtns(item) {
			console.log(item, 7777);
			this.fullscreenLoading = true;
			this.$http
				.get('api/app/common/getUrl', {
					params: {
						fileId: item.recordingFileId,
						clientType: 1
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						axios({
							method: 'get',
							url: res.msg,
							// timeout: 600000, // 请求超时时间，数据量多后台响应慢的情况可以调大点，没生效的话可能是vue.config.js里的配置影响了
							responseType: 'blob', // 返回类型为数据流
							headers: {
								clientType: 1,
								token: `${localStorage.getItem('token')}`
							}
						}).then((red) => {
							if (red && red.data) {
								const blob = new Blob([red.data], { type: 'audio/mpeg' });
								this.$audio.init(URL.createObjectURL(blob), (r) => {});
								this.$nextTick((r) => {
									this.$audio.play();
								});
							}
						});
					}
				});
		},
		tltBtn(items) {
			let set = this.$loading(this.$pre);
			//班级组卷
			this.$http.post(`api/app/yydErrorEdition/${items.examinationQuestionId}/${this.pageType}`).then((res) => {
				set.close();
				if (res.code == 200) {
					this.$message({
						type: 'success',
						message: '加入成功'
					});
				}
			});
		},
		tabFn(item, index) {
			this.tabVal = index;
			this.qkFn();
			this.fxtableFn();
		},
		fxtableFn() {
			console.log(this.tmData.yydGroupExamQuestionBodyDtoList, this.tabVal, 222222222);
			if (this.tabVal == '-1') {
				return;
			}

			if (this.pageType == 6) {
				this.fullscreenLoading = true;
			this.$http
				.post(`api/app/yydComputerizedExamPaper/wrongQuestionDistribution/${this.tmData.yydGroupExamQuestionBodyDtoList[this.tabVal].examinationQuestionId}`, {
					bjId: this.bjId,
					type: this.paperType,
					paperId: this.paperId
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						console.log(res, 2222);
						let arr = [];
						let str = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八'];
						res.data?.forEach((item, index) => {
							arr.push({
								tNum: str[index],
								xuanx: 'A',
								fenbmd: item.answer == 'A' ? '正确' : item.astudent || '',
								hej: `${item.anumber}人`
							});
							arr.push({
								tNum: str[index],
								xuanx: 'B',
								fenbmd: item.answer == 'B' ? '正确' : item.bstudent || '',
								hej: `${item.bnumber}人`
							});
							arr.push({
								tNum: str[index],
								xuanx: 'C',
								fenbmd: item.answer == 'C' ? '正确' : item.cstudent || '',
								hej: `${item.cnumber}人`
							});
						});
						this.tableData = arr;
					}
				});
			} else {
				this.fullscreenLoading = true;
			this.$http
				.post(`api/app/yydAnswerQuestion/wrongQuestionDistribution/${this.tmData.yydGroupExamQuestionBodyDtoList[this.tabVal].examinationQuestionId}`, {
					bjId: this.bjId,
					type: this.pageType,
					bjExamId: this.pageType == 2 || this.pageType == 3 || this.pageType == 5 ? this.ctId : this.examId
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						console.log(res, 2222);
						let arr = [];
						let str = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八'];
						res.data?.forEach((item, index) => {
							arr.push({
								tNum: str[index],
								xuanx: 'A',
								fenbmd: item.answer == 'A' ? '正确' : item.astudent || '',
								hej: `${item.anumber}人`
							});
							arr.push({
								tNum: str[index],
								xuanx: 'B',
								fenbmd: item.answer == 'B' ? '正确' : item.bstudent || '',
								hej: `${item.bnumber}人`
							});
							arr.push({
								tNum: str[index],
								xuanx: 'C',
								fenbmd: item.answer == 'C' ? '正确' : item.cstudent || '',
								hej: `${item.cnumber}人`
							});
						});
						this.tableData = arr;
					}
				});
			}

			
		},
		async init() {
			this.fullscreenLoading = true;
			if (this.pageType == 2) {
				// 每日一听
				await this.$http
					.post(`api/app/yydListenEveryDay/bjPage`, {
						id: this.examId,
						bjId: this.bjId,
						bjExamId: this.ctId,
						type: 2
					})
					.then((res) => {
						this.fullscreenLoading = false;
						if (res.code == 200) {
							console.log(res, 44444);
							let { yydExamination, ...datas } = res.data;
							let i = '';
							let is = false;
							let num = 0;
							datas.yydGroupExamQuestionBodyDtoList = yydExamination?.yydExaminationQuestionList || [];
							datas.yydGroupExamQuestionBodyDtoList.forEach((fitem, findex) => {
								fitem.tmFlag = false;
								fitem?.yydSmallQuestionList.forEach((item, index) => {
									if (item.wrongStuNums && !is) {
										i = findex;
										this.tabInex = index;
										is = true;
									}
									if (!is) {
										num++;
									}
									item.tmFlag = false;
									item.tmVal = '';
								});
							});
							this.tabInex = num;
							this.tabVal = is ? i : '-1';
							this.tmData = datas;
						}
					});
			}
			if (this.pageType == 5) {
				// 试卷
				await this.$http
					.post(`api/app/yydGroupQuestionExam/pagerInfo`, {
						id: this.examId,
						bjId: this.bjId,
						bjExamId: this.ctId,
						type: 5
					})
					.then((res) => {
						this.fullscreenLoading = false;
						if (res.code == 200) {
							console.log(res, 44444);
							let i = '';
							let is = false;
							let num = 0;
							res.data.yydGroupExamQuestionBodyDtoList.forEach((fitem, findex) => {
								fitem.tmFlag = false;
								fitem?.yydSmallQuestionList.forEach((item, index) => {
									if (item.wrongStuNums && !is) {
										is = true;
										i = findex;
									}
									if (!is) {
										num++;
									}
									item.tmFlag = false;
									item.tmVal = '';
								});
							});
							this.tabInex = num;
							this.tabVal = is ? i : '-1';
							this.tmData = res.data;
						}
					});
			}
			if (this.pageType == 3) {
				// 真题
				await this.$http
					.post(`api/app/yydCollegeExamination/bjPage`, {
						id: this.examId,
						bjId: this.bjId,
						bjExamId: this.ctId,
						type: 3
					})
					.then((res) => {
						this.fullscreenLoading = false;
						if (res.code == 200) {
							console.log(res, 44444);
							let { yydExamination, ...datas } = res.data;
							datas.yydGroupExamQuestionBodyDtoList = yydExamination?.yydExaminationQuestionList || [];
							let i = '';
							let is = false;
							let num = 0;
							datas.yydGroupExamQuestionBodyDtoList.forEach((fitem, findex) => {
								fitem.tmFlag = false;
								fitem?.yydSmallQuestionList.forEach((item, index) => {
									if (item.wrongStuNums && !is) {
										is = true;
										this.tabInex = index;
										i = findex;
									}
									if (!is) {
										num++;
									}
									item.tmFlag = false;
									item.tmVal = '';
								});
							});
							this.tabInex = num;
							this.tabVal = is ? i : '-1';
							this.tmData = datas;
						}
					});
			}
			if (this.pageType == 6) {
				// 机考套题
				await this.$http
					.post(`api/app/yydComputerizedExamPaper/pagerInfo`, {
						paperId: this.paperId,
						bjId: this.bjId,
						type: this.paperType
					})
					.then((res) => {
						this.fullscreenLoading = false;
						if (res.code == 200) {
							console.log(res, 44444);
							let i = '';
							let is = false;
							let num = 0;
							res.data.yydGroupExamQuestionBodyDtoList.forEach((fitem, findex) => {
								fitem.tmFlag = false;
								fitem?.yydSmallQuestionList.forEach((item, index) => {
									if (item.wrongStuNums && !is) {
										is = true;
										i = findex;
									}
									if (!is) {
										num++;
									}
									item.tmFlag = false;
									item.tmVal = '';
								});
							});
							this.tabInex = num;
							this.tabVal = is ? i : '-1';
							this.tmData = res.data;
						}
					});
			}
			if (this.pageType == 6) {
				this.$http
					.get(`api/app/yydComputerizedExamPaper/studentAnswerList`, {
						params: {
							paperId: this.paperId,
							bjId: this.bjId,
							type: this.paperType
						}
					})
					.then((res) => {
						if (res.code == 200) {
							console.log(res, 44444);
							this.perData = res.rows || [];
						}
					});
				this.$http
					.get(`api/app/yydComputerizedExamPaper/studentAnswerListEcharts`, {
						params: {
							paperId: this.paperId,
							bjId: this.bjId,
							type: this.paperType
						}
					})
					.then((res) => {
						console.log(res, 9999);
						if (res.code == 200) {
							this.option1.series[0].data = res.data.list;
							this.option2.series[0].data = res.data.listDf;
						}
					});
			} else {
				this.$http
					.get(`api/app/yydAnswerExam/list`, {
						params: {
							bjId: this.bjId,
							bjExamId: this.pageType == 2 || this.pageType == 3 || this.pageType == 5 ? this.ctId : this.examId,
							// examId: this.examId,
							type: this.pageType
						}
					})
					.then((res) => {
						if (res.code == 200) {
							console.log(res, 44444);
							this.perData = res.rows || [];
						}
					});
				this.$http
					.get(`api/app/yydAnswerExam/listEcharts/${this.pageType}/${this.pageType == 2 || this.pageType == 3 || this.pageType == 5 ? this.ctId : this.examId}`)
					.then((res) => {
						console.log(res, 9999);
						if (res.code == 200) {
							this.option1.series[0].data = res.data.list;
							this.option2.series[0].data = res.data.listDf;
						}
					});
			}
			this.fxtableFn();
		},
		fhKeben() {
			if (this.$parent.flags == 3) {
				this.$emit('fhBtn', 'banjiSj');
			} else if (this.$parent.flags == 4) {
				this.$emit('fhBtn', 'gaokaoZts');
			} else if (this.$parent.flags == 5) {
				this.$emit('fhBtn', 'meiriYts');
			} else if (this.$parent.flags == 8) {
				this.$emit('fhBtn', 'jikaoSj');
			}
		},
		yusFn(type) {
			if (type == '-') {
				if (this.bsIns == 0) return;
				this.bsIns--;
			} else {
				if (this.bsIns == 5) return;
				this.bsIns++;
			}
			this.$audio.playbackRate(this.bsData.slice(this.bsIns, this.bsIns + 1)[0]);
		},
		fxFn() {
			this.fxFlag = true;
			this.$nextTick(() => {
				// 初始化ECharts实例
				// this.myChart1 = echarts.init(this.$refs.myChart1);
				// 使用刚指定的配置项和数据显示图表。
				// this.myChart1.setOption(this.option1);
				// 初始化ECharts实例
				this.myChart2 = echarts.init(this.$refs.myChart2);
				// 使用刚指定的配置项和数据显示图表。
				this.myChart2.setOption(this.option2);
			});
		}
	},
	mounted() {
		this.init();
	}
};
</script>
<style lang="scss" scoped>
::v-deep .btClass {
	.cell {
		font-size: 14px !important;
		color: #000000 !important;
		font-weight: bold !important;
	}
}
.kbBox {
	.kbTit {
		height: 80px;
		display: flex;
		align-items: center;
		padding: 0 26px 0 16px;
		justify-content: space-between;
		.kbFanh {
			cursor: pointer;
		}
		.kbTj {
			display: flex;
			align-items: center;
			font-size: 14px;
			cursor: pointer;
			color: #000000;
			line-height: 1;
			img {
				width: 22px;
				height: 22px;
				margin-right: 4px;
			}
			i {
				margin-right: 4px;
				font-size: 16px;
			}
		}
	}
	.kbTjRig {
		display: flex;
		align-items: center;
	}
}
.dfIcon {
	display: flex;
	align-items: center;
	justify-content: center;
	color: #1d7b3a;
	font-size: 14px;
	img {
		margin-right: 4px;
		width: 14px;
		height: 14px;
	}
}
.dfIcon1 {
	color: #fa4a1b;
}
.tjBoxs {
	display: flex;
	justify-content: center;
	.tjBoxItem {
		margin-bottom: 30px;
		margin-top: -50px;
	}
}
.banjJcBtn {
	width: 90px;
	height: 30px;
	background: #fa4a1b;
	border-radius: 4px;
	font-size: 14px;
	color: #ffffff !important;
	margin-left: 18px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	i {
		font-size: 16px;
		margin-right: 4px;
	}
}
.kbCont {
	padding: 17px 28px;
	position: relative;
	border-top: 2px solid #eeeff2;
}
.kaoshiCont {
	color: #000000;
	h1 {
		font-size: 28px;
		padding-top: 38px;
		margin-bottom: 25px;
		font-weight: bold;
		text-align: center;
	}
	h2 {
		font-size: 18px;
		margin-bottom: 27px;
		text-align: center;
		padding-bottom: 34px;
		border-bottom: 1px solid #f8f8f8;
	}
	.kaoshiTm {
		.kaoshiTmFbts {
			font-size: 14px;
			color: #3d3d3d;
			margin-bottom: 15px;
		}
		.kaoshiTmFbt {
			font-size: 18px;
			color: #3d3d3d;
			display: flex;
			align-items: center;
			margin-bottom: 34px;
			.kaoshiWtBtn {
				margin-left: 19px;
				width: 63px;
				height: 26px;
				background: #1d7b3a;
				border-radius: 4px;
				color: #fff;
				font-size: 14px;
				display: flex;
				justify-content: center;
				align-items: center;
				font-weight: 400;
				cursor: pointer;
				img {
					width: 16px;
					height: 14px;
					margin-right: 6px;
				}
			}
		}
		h3 {
			font-size: 18px;
			font-weight: bold;
			margin: 40px 0 13px;
			text-indent: 2em;
		}
		> p {
			font-size: 16px;
			line-height: 2;
			text-indent: 2em;
			margin-bottom: 38px;
		}
		h4 {
			font-weight: bold;
			font-size: 18px;
			margin: 40px 0;
		}
		.kaoshiT {
			margin-bottom: 40px;
			&:last-of-type {
				margin-bottom: 0;
			}
			.kaoshiXx {
				padding-left: 102px;

				p {
					margin-bottom: 36px;
					font-size: 18px;
					cursor: pointer;

					&:last-of-type {
						margin-bottom: 0;
					}
				}
				.active {
					color: #1d7b3a;
				}
			}
			.kaoshiWt {
				display: flex;
				font-weight: bold;
				margin-bottom: 36px;

				.kaoshiDa {
					width: 72px;
					margin-right: 30px;
					position: relative;
					display: flex;
					justify-content: space-between;
					span {
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
						line-height: 1;
						margin-top: -1px;
					}
				}
			}
		}
		.lookJxWrapper {
			.lookJx {
				color: #1d7b3a;
				cursor: pointer;
				margin: 30px 0 20px 31px;
			}
			.lookDaBox {
				margin-left: 31px;
				.lookDaTit {
					font-weight: bold;
					font-size: 18px;
					margin-bottom: 16px;
					span {
						margin-right: 10px;
					}
				}
				.lookDaCont {
					margin-bottom: 20px;
					line-height: 2;
					font-size: 16px;
					color: #000000;
					span {
						color: #1d7b3a;
					}
				}
				.lookDaBtn {
					width: 88px;
					height: 40px;
					border: 1px solid #1d7b3a;
					text-align: center;
					line-height: 40px;
					font-size: 16px;
					color: #1d7b3a;
					cursor: pointer;
					border-radius: 6px;
				}
			}
		}
	}
}
.kaoshiFixYs {
	position: sticky;
	float: right;
	top: 22px;
	right: 7px;
	width: 108px;
	height: 98px;
	color: #fff;
	background: url('@/assets/img/ys.svg') 100% no-repeat;
	.kaoshiFixYsCont {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		margin-top: -4px;
	}
	.kaoshiFixP {
		position: absolute;
		bottom: 15px;
		width: 100%;
		display: flex;
		justify-content: center;
		font-size: 12px;
		align-items: center;
		p {
			margin: 0 6px;
		}
		img {
			width: 9px;
			height: 6px;
			cursor: pointer;
			margin-top: 1px;
		}
		.img1 {
			transform: rotate(90deg);
		}
		.img2 {
			transform: rotate(90deg);
		}
	}
}
.ctTabelBox {
	padding: 0 10px;
	.ctTabelTit {
		height: 46px;
		background: #f3f4f7;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: space-around;
		.ctTabelTitItem {
			width: 35px;
			height: 35px;
			font-size: 14px;
			color: #000000;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
	.ctTabelCont {
		height: 61px;
		display: flex;
		justify-content: space-around;
		align-items: center;
		.ctTabelContItem {
			width: 35px;
			height: 35px;
			font-size: 14px;
			color: #000000;
			display: flex;
			justify-content: center;
			align-items: center;
			cursor: pointer;
		}
		.ctTabelContItemActive {
			width: 35px;
			height: 35px;
			background: #1d7b3a;
			color: #fff;
			border-radius: 50%;
		}
	}
}
</style>
